<collapsible-card title="{{fullTitle}}"
  [postTitle]="postTitle"
  [loading]="loading"
  [error]="error">
@if (!loading && !error) {
  <data-table [frontEndPaging]="true"
    [isMobile]="isMobile"
    [columns]="columns"
    [rows]="rows"
    [noteProp]="noteProp"
    [noResultsMessage]="noResultsMessage"
    (onExternalLinkClick)="externalLinkClicked($event)"
    (onRowClick)="rowClicked($event)">
  </data-table>
}
</collapsible-card>
